<template>
  <div class="flex-center position-ref full-height">
    <div class="content">
      <transition name="fade">
        <div class="title m-b-md" v-show="show">BIS Guias</div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false
    };
  },
  created() {
    var fin = this.fadein;
    var fout = this.fadeout;
    var r = this.redirect;
    setTimeout(function() {
      fin();
      setTimeout(function() {
        fout();
        setTimeout(function() {
          r();
        }, 1000);
      }, 1000);
    }, 200);
  },
  methods: {
    fadein() {
      console.log("fadein");
      this.show = true;
    },
    fadeout() {
      console.log("fadeout");
      this.show = false;
    },
    redirect() {
      let nextUrl = this.$store.getters.hasAcceptedTerms ? '/ordens': '/aceitacao-do-manual-do-guia';
      this.$router.push(nextUrl);
    }
  }
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=Raleway:100,600");

.full-height {
  background-color: #fff;
  color: #636b6f;
  font-family: "Raleway", sans-serif;
  font-weight: 100;
  height: 100vh;
  margin: 0;
}

.flex-center {
  align-items: center;
  display: flex;
  justify-content: center;
}

.position-ref {
  position: relative;
}

.top-right {
  position: absolute;
  right: 10px;
  top: 18px;
}

.content {
  text-align: center;
}

.title {
  font-size: 84px;
  display: block;
}

.links > a {
  color: #636b6f;
  padding: 0 25px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.1rem;
  text-decoration: none;
  text-transform: uppercase;
}

.m-b-md {
  margin-bottom: 30px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active em versões anteriores a 2.1.8 */ {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/welcome/Welcome.vue